/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.YieldManagementProgram {
    export interface IProgramServices {
        serviceId?: string;
        programAdjustmentOverride?: ProgramAdjustmentOverrideEnum;
        adjustment?: number;
        shortCut?: string;
        displayName?: string;
        locationId?: number;

        coProgramAdjustmentOverride?: ProgramAdjustmentOverrideEnum;
        coAdjustment?: number;
    }

    export class ProgramServices implements IProgramServices {
        programAdjustmentOverride: ProgramAdjustmentOverrideEnum;
        adjustment?: number;
        serviceId?: string;
        coProgramAdjustmentOverride?: ProgramAdjustmentOverrideEnum;
        coAdjustment?: number;

        get programAdjustmentOverrideValue() {
            return this.programAdjustmentOverride;
        }

        set programAdjustmentOverrideValue(value) {
            this.programAdjustmentOverride = value;

            if (value === ProgramAdjustmentOverrideEnum.NoOverride) {
                this.adjustment = null;
            } else {
                this.adjustment = 0;
            }
        }

        get showRevert(): boolean {
            return this.coProgramAdjustmentOverride !== this.programAdjustmentOverride
                || this.coAdjustment !== this.adjustment;
        }

        constructor(item: IProgramServices = {}) {
            Object.assign(this, item);
        }

        revert() {
            this.programAdjustmentOverride = this.coProgramAdjustmentOverride;
            this.adjustment = this.coAdjustment;
        }
    }
}
